module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l((_vm.swiperlist), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "swiper-slide",
      style: ('background-image:url(' + item.imageUrl + ')'),
      attrs: {
        "alt": item.title
      }
    }, [_c('a', {
      attrs: {
        "href": item.link
      }
    })])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination"
  }), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swip-btn"
  }, [_c('div', {
    staticClass: "swiper-button-prev"
  }, [_c('span')]), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next"
  }, [_c('span')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e87178a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/banner.vue
// module id = 21
// module chunks = 0